// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"957ab079","458":"9bc08cf0"}[chunkId] + ".chunk.js";
};